<!-- 省 -->
<template>
  <div class="city-box">
    <el-select v-model="selectValue" value-key="value" @change="changeValue"  filterable placeholder="省">
      <el-option label="请选择" value=""></el-option>
      <template  v-for="(city,key) in cityData">
        <el-option
          v-for="item in city"
          :key="item.label"
          :label="item.label"

          :value="item">
        </el-option>
      </template>

    </el-select>

  </div>
</template>

<script>

  export default {
    name: "select-city",
    props:['value'],
    data() {
      return {
        selectValue:""
      }
    },
    mixins: [tableBase],
    computed:{
      cityData(){
        return this.$store.state.regionMap;
      }
    },
    watch:{
      value(){
        this.selectValue = this.value;
      }
    },
    methods: {
      changeValue(value){
        console.log(value);
        this.$emit('update:modelValue',value);
      }
    },
    mounted() {
      this.selectValue = this.value;
    }
  }
</script>

<style lang="less" scoped>
  .city-box{
    display: flex;
    justify-content: space-between;
    .el-select{
      flex: 1 1 auto;
      margin-right: 20px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>
